import { IsOptional, IsString, IsUUID, ValidateIf } from 'class-validator';

export class CreateTempExcursionPostReleaseConfigRequestDto {
    /**
     * How events are logged
     * @example 'Electronic system with manual backup'
     */
    @IsOptional()
    @IsString()
    howEventLogged?: string;

    /**
     * Intake organization ID
     * @example '123e4567-e89b-12d3-a456-426614174000'
     */
    @IsOptional()
    @ValidateIf((o) => o.intakeOrganizationId !== '' && o.intakeOrganizationId != null)
    @IsUUID()
    intakeOrganizationId?: string;

    /**
     * Client QA contact email
     * @example 'qa.contact@client.com'
     */
    @IsOptional()
    @IsString()
    clientQaContactEmail?: string;

    /**
     * Client procedure reference
     * @example 'SOP-TEMP-EX-2024-v1.0'
     */
    @IsOptional()
    @IsString()
    clientProcedureRef?: string;

    /**
     * Notes
     * @example 'Follow temperature monitoring guidelines'
     */
    @IsOptional()
    @IsString()
    notes?: string;
}
